import { LinearProgress, withStyles } from "@material-ui/core";

const BorderLinearProgress = withStyles(() => ({
  root: {
    borderRadius: 0,
    height: 14,
  },
  colorPrimary: {
    backgroundColor: "transparent",
  },
  bar: {
    transition: "none",
  },
}))(LinearProgress);

export default BorderLinearProgress;
